export enum ClassroomsAdministrationScopes {
  CAN_VIEW = 'can_view_classrooms_administration',
  CAN_IMPORT_GOOGLE_CLASSROOM = 'can_import_google_classroom',
  CAN_CREATE_CLASSROOM_MANUALLY = 'can_create_classroom_manually',
}
